export default "__VITE_ASSET__BxJ7VP89__"